import t from "../../context/index.js";

import { useContext as o } from "react";

const r = () => o(t);

export { r as default };
//# sourceMappingURL=index.js.map
